module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig11_helix-deviation-lead-crown.7cbc7342.png";